import flatpickr from 'flatpickr';
import axios from '../../shared/axios';
const NL = require('flatpickr/dist/l10n/nl.js').default.nl;

export function store(data, params)
{
    return axios.post(Jobtoolz.api.url + '/content/v1/applications', data, { params })
    .then(response => response.data);
}

export function update(applicationId, accessToken, data)
{
    return axios.patch(
        Jobtoolz.api.url + '/content/v1/applications/' + applicationId,
        data,
        { headers: { 'X-Application-Access-Token': accessToken } }
    ).then(response => response.data);
}

export function resetFormErrors(field)
{
	field = (typeof field == 'undefined') ? '' : '="' + field + '"';

	let el;

	// only hide general errors when we want to reset all fields
	if (field == '') {
		el = document.querySelector('[data-role="errors-feedback"]');
		if (el) {
			el.classList.add('hidden');
		}
	}

	el = document.querySelectorAll('[data-error-feedback' + field + ']');
	if (el) {
		el.forEach(e => {
			e.classList.add('hidden');
			e.innerText = '';
		});
	}

	el = document.querySelectorAll('[data-error-background' + field + ']');
	if (el) {
		el.forEach(e => e.classList.remove('bg-semantic-error'));
	}

	el = document.querySelectorAll('[data-error-border' + field + ']');
	if (el) {
		el.forEach(e => e.classList.remove('border-semantic-error'));
	}

	el = document.querySelectorAll('[data-error-text' + field + ']');
	if (el) {
		el.forEach(e => e.classList.remove('text-semantic-error'));
	}
}

export function resetIndexesForDynamicField(field)
{
	let el = document.querySelectorAll('[data-clone-dest="' + field + '"] [data-role="index"]');
	if (el) {
		let index = 1;
		el.forEach(e => e.innerHTML = index++);
	}
}

export function setDynamicFields(field)
{
	let button = document.querySelector('[data-role="add-' + field + '"]');
	if (button) {
		button.addEventListener('click', () => {
			let dst = document.querySelector('[data-clone-dest="' + field + '"]'),
				src = document.querySelector('[data-clone-source="' + field + '"]')
				;

			if (dst && src) {
				// clone node
				let clone = src.cloneNode(true);

				// set new index for our elements
				let index = document.querySelector('[data-clone-source="' + field + '"]');
				index.dataset.index++;

				// set search/replace vars
				let elements = [],
					strSearch = new RegExp(field + '-0-', 'g'),
					strReplace = field + '-' + index.dataset.index + '-'
					;

				// reset some html
				clone.querySelectorAll('input')
					.forEach(element => {
						element.value = '';

						elements.push(element.name);
					});
				clone.querySelectorAll('textarea')
					.forEach(element => {
						element.value = '';

						elements.push(element.name);
					});
				clone.innerHTML = clone.innerHTML.replace(strSearch, strReplace);

				// remove some html
				let el;

				// remove flatpickr
				el = clone.querySelectorAll('[readonly].custom-flatpickr');
				if (el) {
					el.forEach(element => element.parentNode.removeChild(element));
				}
				el = clone.querySelectorAll('[type="hidden"].custom-flatpickr');
				if (el) {
					el.forEach(element => element.type = 'text');
				}

				// iterate through nodes and clone
				clone.childNodes.forEach(node => {
					node = document.importNode(node, true);
					dst.appendChild(node);
				});

				// remove errors ?
				elements.forEach(element => {
					if (element != '') {
						resetFormErrors(element.replace(strSearch, strReplace));
					}
				});

				// now reset flatpickr
				setFlatpickr();

				// and now bind delete action
				el = dst.querySelectorAll('[data-role="delete"]');
				if (el) {
					el[el.length - 1].addEventListener('click', e => {
						let node = e.target.parentNode.parentNode.parentNode.parentNode;
						node.parentNode.removeChild(node);

						resetIndexesForDynamicField(field);
					});
				}

				resetIndexesForDynamicField(field);
			}
		});

		// trigger click on load ?
		let el = document.querySelector('[data-clone-source="' + field + '"][data-required]');
		if (el) {
			button.click();

			// and remove first delete button
			el = document.querySelector('[data-clone-dest="' + field + '"] [data-role="delete"]');
			if (el) {
				el.parentNode.removeChild(el);
			}
		}
	}
}

export function setFormErrors(field, errors)
{
    let parts = field.split('.');

    if (parts.length === 3) {
        parts[1] = parseInt(parts[1]) + 1;
    }

    field = parts.join('-');

	let el;

	el = document.querySelectorAll('[data-error-feedback="' + field + '"]');
	if (el) {
		el.forEach(e => {
			e.classList.remove('hidden');
			e.innerText = errors.join('<br>');
		});
	}

	el = document.querySelectorAll('[data-error-background="' + field + '"]');
	if (el) {
		el.forEach(e => e.classList.add('bg-semantic-error'));
	}

	el = document.querySelectorAll('[data-error-border="' + field + '"]');
	if (el) {
		el.forEach(e => e.classList.add('border-semantic-error'));
	}

	el = document.querySelectorAll('[data-error-text="' + field + '"]');
	if (el) {
		el.forEach(e => e.classList.add('text-semantic-error'));
	}
}

export function setFlatpickr()
{
	window.fp = window.fp || {};

	let elements = document.querySelectorAll('.custom-flatpickr');
	if (elements) {
		elements.forEach(el => {
			if ((el.name != '') && (typeof window.fp[el.name] == 'undefined')) {
                let locale = el.dataset.locale;
				window.fp[el.name] = flatpickr(el, {
		            altFormat: 'j F Y',
		            altInput: true,
		            dateFormat: 'Y-m-d',
                    locale: locale,
				});

				// iterate through dataset and clone them se can display the errors
				Object.keys(window.fp[el.name].element.dataset).forEach(key => {
					window.fp[el.name].altInput.dataset[key] = window.fp[el.name].element.dataset[key];
				});
			}
		});
	}
}
